import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { formsClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation ResendFormMails($formSendId: Int) {
    resendFormMails(formSendId: $formSendId) {
      id
    }
  }
`

export const useResendFormInvite = () => {
  const { t } = useTranslation('listForms')
  const notify = useNotification()

  const [request, state] = useMutation(MUTATION, {
    client: formsClient
  })

  const handleRequest = formSendId => {
    return request({ variables: { formSendId } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: t('sentSuccessfully') })
      } else {
        notify.error({ title: t('common:errorMessage') })
      }
    })
  }

  return [handleRequest, state]
}
